import api from '@/services/api'

export const updateTargetStatus = async (id, status) => {
    return api.put(`goals/${id}/update-status`, {
        status,
    })
}
